import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from '../../theme';
import useActionButtonStyles from './ActionButton.Styles';
import { CircleTickIcon, CircleCancelIcon } from '../../icons';
// Component
export const Button = ({ disabled = false, variant = 'default', fullWidth, className, sx, children, ...props }) => {
    const theme = useTheme();
    const styles = useActionButtonStyles({
        ...{ fullWidth, disabled, ...props },
        theme
    });
    const variantStyle = styles[variant];
    return (_jsxs("button", { className: `${styles.common} ${disabled ? styles.disabled : ''} ${variantStyle} ${className}`, disabled: disabled, ...props, style: sx, children: [variant === 'success' ? _jsx(CircleTickIcon, { color: "#fff" }) : null, variant === 'error' ? _jsx(CircleCancelIcon, { color: "#fff" }) : null, children] }));
};
export default Button;
